import { tryCatchHelper } from '../../../helpers';
import {
  deleteTiposEventosService,
  getAllTiposEventosService,
  getOneTiposEventosService,
  saveTiposEventosService,
} from '../../../services';
import {
  ACTIVO_TIPOS_EVENTOS,
  GETALL_TIPOS_EVENTOS,
  LOADING_GETALL_TIPOS_EVENTOS,
} from '../../../store/Types';

export const getAllTiposEventosAction = async (dispatch, entityId) => {
  try {
    dispatch({
      type: LOADING_GETALL_TIPOS_EVENTOS,
      payload: true,
    });
    const res = await getAllTiposEventosService({ entityId });
    if (res.status === 200) {
      dispatch({
        type: GETALL_TIPOS_EVENTOS,
        payload: res.data,
      });
      dispatch({
        type: LOADING_GETALL_TIPOS_EVENTOS,
        payload: false,
      });
      return res.data;
    }
    dispatch({
      type: LOADING_GETALL_TIPOS_EVENTOS,
      payload: false,
    });
    return null;
  } catch (e) {
    dispatch({
      type: LOADING_GETALL_TIPOS_EVENTOS,
      payload: false,
    });
    let message =
      e.response?.data?.message ||
      e.message ||
      'Error al intentar, realizar el proceso';
    if (Array.isArray(e.message)) message = e.message.join(', ');
    if (Array.isArray(e.response?.data?.message)) {
      message = e.response?.data?.message.join(', ');
    }
    console.warn(message);
  }
};

export const saveTiposEventosAction = async (
  { dispatch, addNotification },
  entityId,
  id,
  data
) => {
  try {
    const res = await saveTiposEventosService(id, data);
    addNotification(
      res.message ?? id
        ? 'El tipo de documento actualizado.'
        : 'El tipo de documento registrado.'
    );
    await getAllTiposEventosAction(dispatch, entityId);
    return true;
  } catch (e) {
    tryCatchHelper({ e, addNotification });
    return false;
  }
};

export const setActivoTiposEventosAction = async (dispatch, data) => {
  dispatch({
    type: ACTIVO_TIPOS_EVENTOS,
    payload: data,
  });
};

export const getOneTiposEventosAction = async (dispatch, id) => {
  try {
    const res = await getOneTiposEventosService(id);
    if (res.status === 200) {
      await setActivoTiposEventosAction(dispatch, res.data);
      return true;
    }
    return false;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteTiposEventosAction = async (
  { dispatch, addNotification },
  id,
  entityId
) => {
  try {
    const res = await deleteTiposEventosService(id, entityId);
    if (res.status === 200) {
      addNotification(res.data?.message ?? 'Tipo de documento eliminado.');
      await setActivoTiposEventosAction(dispatch, null);
      await getAllTiposEventosAction(dispatch, entityId);
      return true;
    }
    return false;
  } catch (e) {
    tryCatchHelper({ e, addNotification });
    return false;
  }
};
